module.exports = __webpack_public_path__ + "img/art-8.ac3af49d.png";